enum ExtPlatType {
    Facebook = "facebook",
    Youtube = "youtube",
    Twitch = "twitch"
}

interface IExtPlatAuthView {
    extPlatAuthId: number,
    cId: number,
    userLabel: string,
    extPlatType: ExtPlatType,
    fb: IExtPlatAuthFBView,
    yt: IExtPlatAuthYTView,
    twitch: IExtPlatAuthTwitchView,
    lastErrorCode: string | null,
    lastErrorMsg: string | null,
    lastToken: number | null,
    lastTokenTest: number | null,
    created: number,
    updated: number
}

interface IExtPlatAuthFBView {
    fbAppId: string | null,
    fbUserAccessTokenExpires: number | null,
    fbUserId: string | null,
    fbLonglivedUserAccessTokenExpires: number | null
}

interface IExtPlatAuthYTView {
    ytAccessTokenExpires: number | null,
    ytClientId: string | null,
    ytScope: string | null
}

interface IExtPlatAuthTwitchView {
    twitchClientId: string | null,
    twitchAccessTokenExpires: number | null,
    twitchScope: string | null
}

interface IExtPlatAuthCreateOrUpdateReq {
    userLabel: String,
    extPlatType: ExtPlatType,
    fb: IExtPlatAuthFBCreateOrUpdateReq,
    yt: IExtPlatAuthYTCreateReq,
    twitch: IExtPlatAuthTwitchView
}

interface IExtPlatAuthFBCreateOrUpdateReq {
    fbAppId: string | null,
    fbUserAccessToken: string | null,
    fbUserAccessTokenExpiresIn: number | null,
    fbUserId: string | null
}

interface IExtPlatAuthYTCreateReq {
    ytClientId: string | null,
    ytCode: string | null,
    ytScope: string | null
}

interface IExtPlatAuthCheckTokensReq {
    extPlatAuthIds: number[];
}

class ExtPlatAuthUtil {

    private static createEmptyFBReq(): IExtPlatAuthFBCreateOrUpdateReq {
        return {
            fbAppId: null,
            fbUserAccessToken: null,
            fbUserAccessTokenExpiresIn: null,
            fbUserId: null,
        };
    }

    private static createEmptyYTReq(): IExtPlatAuthYTCreateReq {
        return {
            ytScope: null,
            ytCode: null,
            ytClientId: null
        };
    }

    private static createEmptyTwitchReq(): IExtPlatAuthTwitchView {
        return {
            twitchAccessTokenExpires: null,
            twitchClientId: null,
            twitchScope: null
        };
    }

    static createFBCreateOrUpdateReq(
        fbAppId: string,
        userAccessToken: string,
        userAccessTokenExpiresIn: number,
        userLabel: string,
        userId: string
    ): IExtPlatAuthCreateOrUpdateReq {
        return {
            userLabel: userLabel,
            extPlatType: ExtPlatType.Facebook,
            fb: {
                fbAppId: fbAppId,
                fbUserAccessToken: userAccessToken,
                fbUserAccessTokenExpiresIn: userAccessTokenExpiresIn,
                fbUserId: userId,
            },
            yt: ExtPlatAuthUtil.createEmptyYTReq(),
            twitch: ExtPlatAuthUtil.createEmptyTwitchReq()
        };
    }

    static createYTCreateReq(
        scope: string,
        userLabel: string,
        ytClientId: string,
        ytCode: string
    ): IExtPlatAuthCreateOrUpdateReq {
        return {
            userLabel: userLabel,
            extPlatType: ExtPlatType.Youtube,
            fb: ExtPlatAuthUtil.createEmptyFBReq(),
            yt: {
                ytScope: scope,
                ytClientId: ytClientId,
                ytCode: ytCode
            },
            twitch: ExtPlatAuthUtil.createEmptyTwitchReq()
        };
    }
}

export {
    ExtPlatAuthUtil,
    ExtPlatType,
    IExtPlatAuthView,
    IExtPlatAuthFBView,
    IExtPlatAuthYTView,
    IExtPlatAuthTwitchView,
    IExtPlatAuthCreateOrUpdateReq,
    IExtPlatAuthCheckTokensReq
}